<template>

    <div class="c-summary">
        <slot></slot>
    </div>

</template>


<script>

export default {

    name: 'SummaryMain'

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-summary {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    flex-shrink: 0;
    font-size: $font-base-size;

    @include bp($screen-lg) {
        flex-direction: column;
    }
}

</style>
